module.exports = __webpack_public_path__ + "static/img/WITZIGFRANK.f7d4d523.png";